import React from "react";
import { Stack } from "@mui/material";
import { Attachments, CommonInfo } from "./sections";

export const FormSections = () => {
  return (
    <Stack gap="1.5rem">
      <CommonInfo />
      <Attachments />
    </Stack>
  );
};
